import "./App.css";
import "./app/common/styles/scrollbar.styles.css";
import "./app/common/styles/auth.form.styles.css";
import "./app/common/styles/media.queries/general.media.queries.css";
import "./app/common/styles/border.styles.css";
import "./app/common/styles/card.styles.css";
import "./app/common/styles/dropdown.styles.css";
import "./app/common/styles/icons.styles.css";
import "./app/common/styles/label.styles.css";
import "./app/common/styles/margin.styles.css";
import "./app/common/styles/modals.styles.css";
import "./app/common/styles/text.styles.css";
import "./app/common/styles/ul.styles.css";
import "./app/common/styles/badge.styles.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { CommonRoutes, MerchantRoutes } from "./app/routes";
import { useEffect } from "react";
import { createAxiosResponseInterceptor } from "./app/utils/createAxiosResponseInterceptor";
import { Outlet } from "react-router-dom";

function App() {
  useEffect(() => {
    createAxiosResponseInterceptor();
  });
  return (
    <>
      <CommonRoutes />
      <MerchantRoutes />
      <Outlet />
      <ToastContainer
        autoClose={5000}
        hideProgressBar={true}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        progress={undefined}
      />
    </>
  );
}

export default App;
